const portfolio = [
	{
		name: 'Dossier',
		description: {
			en: 'High-Performance Headless Shopify Plus Storefront Using Remix',
			ro: 'Storefront Shopify Plus Headless de Înaltă Performanță Folosind Remix',
		},
		internalUrl: '/work/shopify-hydrogen-dossier',
		externalUrl: 'https://dossier.co/',
		featuredImage: 'dossier',
		hasCaseStudy: true,
		hasPage: true,
	},
	{
		name: 'Blackstone Unlimited',
		description: {
			en: 'Magento 2 to Shopify Plus Migration for Digital Library System',
			ro: 'Migrare Magento 2 la Shopify Plus pentru Sistem Digital de Bibliotecă',
		},
		internalUrl: '/work/blackstone-unlimited',
		externalUrl: 'https://www.blackstoneunlimited.com/',
		featuredImage: 'blackstone-unlimited',
		hasCaseStudy: true,
		hasPage: true,
	},
	{
		name: 'Peter Dobias',
		description: {
			en: 'Revitalizing Pet Health E-commerce: The Dr. Peter Dobias Success Story',
			ro: 'Revitalizarea e-commerce pentru sănătatea animalelor: Cazul de succes Dr. Peter Dobias',
		},
		internalUrl: '/work/peter-dobias',
		externalUrl: 'https://peterdobias.com/',
		featuredImage: 'peter-dobias',
		hasCaseStudy: true,
		hasPage: true,
	},
	{
		name: 'Fyne Jewellery',
		description: {
			en: 'Design, Custom Shopify Components, Store and Speed Optimisation.',
			ro: 'Design, componente personalizate Shopify, magazin și optimizare viteză.',
		},
		internalUrl: '/work/fyne-jewellery',
		externalUrl: 'https://fynejewellery.com',
		featuredImage: 'fyne-jewellery',
		hasCaseStudy: true,
		hasPage: true,
	},
	{
		name: 'Hugh Maguire',
		description: {
			en: 'Bespoke Shopify Theme Design, WooCommerce Migration and CRO.',
			ro: 'Design temă personalizată Shopify, migrare WooCommerce și CRO.',
		},
		internalUrl: '/work/hugh-maguire',
		externalUrl: 'https://hughmaguirebutchers.com',
		featuredImage: 'hugh-maguire',
		hasCaseStudy: true,
		hasPage: true,
	},
	{
		name: 'A&S Market',
		description: {
			en: 'Bespoke Theme Development, Custom Functionalities, Additional Apps Integration.',
			ro: 'Dezvoltare temă personalizată, funcționalități personalizate, integrare aplicații suplimentare.',
		},
		internalUrl: '/work/as-market',
		externalUrl: 'https://www.asmarket.co.uk',
		featuredImage: 'as-market',
		hasCaseStudy: true,
		hasPage: true,
	},
	{
		name: 'TOPL Cup',
		description: {
			en: 'Design & Custom Theme Development, Personalisation Tool and Hubspot Integration.',
			ro: 'Design și dezvoltare temă personalizată, instrument de personalizare și integrare Hubspot.',
		},
		internalUrl: '/work/topl-cup',
		externalUrl: 'https://toplcup.com',
		featuredImage: 'topl-cup',
		hasCaseStudy: true,
		hasPage: true,
	},
	{
		name: 'SavinSkin',
		description: {
			en: 'Custom Shopify Theme with Additional Components & Functionalities.',
			ro: 'Tema personalizată Shopify cu componente și funcționalități suplimentare.',
		},
		internalUrl: '/work/savin-skin',
		externalUrl: 'https://savinskin.com',
		featuredImage: 'savinskin',
		hasCaseStudy: false,
		hasPage: true,
	},
	{
		name: 'Verlin',
		description: {
			en: 'OpenCart to Shopify Migration, Design and Custom Pages & Components.',
			ro: 'Migrare OpenCart la Shopify, design și pagini și componente personalizate.',
		},
		internalUrl: '/work/verlin',
		externalUrl: 'https://verlin.ro',
		featuredImage: 'verlin',
		hasCaseStudy: false,
		hasPage: true,
	},
	{
		name: 'Lovyt',
		description: {
			en: 'New Shopify Store Setup, Apps Integration and Additional Components',
			ro: 'Setare magazin nou Shopify, integrare aplicații și componente suplimentare',
		},
		internalUrl: '/work/lovyt',
		externalUrl: 'https://lovyt.com',
		featuredImage: 'lovyt',
		hasCaseStudy: false,
		hasPage: true,
	},
	{
		name: 'Folkingtons',
		description: {
			en: 'New Flexible, Scalable and Reusable Components based on new Design.',
			ro: 'Componente flexibile, scalabile și reutilizabile bazate pe design nou.',
		},
		internalUrl: '/work/folkingtons',
		externalUrl: 'https://www.folkingtons.co.uk',
		featuredImage: 'folkingtons',
		hasCaseStudy: false,
		hasPage: true,
	},
	{
		name: 'Hytropics',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://hytropics.com',
		featuredImage: 'Hytropics',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Concept Office',
		description: {
			en: 'Modern Digital Showcase for Office Stationery Provider',
			ro: 'Prezentare Digitală Modernă pentru Furnizor de Articole de Birou',
		},
		internalUrl: '/work/concept-office',
		externalUrl: 'https://conceptoffice.com',
		featuredImage: 'concept-office',
		hasCaseStudy: true,
		hasPage: true,
	},
	{
		name: 'Bestiarum',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://bestiarumgames.com',
		featuredImage: 'Bestiarum',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'MyGeisha',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://mygeisha.ro',
		featuredImage: 'mygeisha',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Alienstore',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://alienstore.ro',
		featuredImage: 'Alienstore',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Apiland',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://apiland.ro',
		featuredImage: 'Apiland',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'NewPharma',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://newpharma.ro',
		featuredImage: 'NewPharma',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Haaus',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://haaus.ro',
		featuredImage: 'Haaus',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Hoolens',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://hoolens.ro',
		featuredImage: 'Hoolens',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Prestige',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://prestigehome.ro',
		featuredImage: 'Prestige',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Ramona Albert',
		description: {
			en: 'Technical & Content SEO, Shopify Maintenance, 3D Models Integration.',
			ro: 'SEO tehnic și de conținut, mentenanță Shopify, integrare modele 3D.',
		},
		internalUrl: '/work/ramona-albert',
		externalUrl: 'https://ramonaalbert.shop',
		featuredImage: 'ramona-albert',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'MiaStela',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://miaandstela.com/',
		featuredImage: 'MiaStela',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Giant Lifting',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://giantlifting.com',
		featuredImage: 'Giant Lifting',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Biotiful',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://biotifulbrands.com/',
		featuredImage: 'Biotiful',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Acupress Ear',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://acupressear.com/',
		featuredImage: 'Acupress Ear',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Friddi',
		description: { en: '', ro: '' },
		internalUrl: '',
		externalUrl: 'https://friddi.ro',
		featuredImage: 'Friddi',
		hasCaseStudy: false,
		hasPage: false,
	},
	{
		name: 'Evcoms',
		description: {
			en: 'Wordpress Brochure Website, Woocommerce Integration and Job Application Form Service.',
			ro: 'Site de prezentare Wordpress, integrare Woocommerce și serviciu de formular de aplicare pentru job.',
		},
		internalUrl: '/work/evcoms',
		externalUrl: 'https://www.evcoms.com',
		featuredImage: 'evcoms',
		hasCaseStudy: false,
		hasPage: false,
	},
];

export default portfolio;
